const calculateAgeInYears = (dob: Date): number => {
  const now = new Date();
  const birthYear = dob.getFullYear();
  const currentYear = now.getFullYear();
  return currentYear - birthYear;
};

export default calculateAgeInYears;
